import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AuthProvider } from 'react-oidc-context';

const authority = process.env.REACT_APP_OIDC_AUTHORITY;

// https://github.com/IdentityModel/oidc-client-js/wiki

const OAuthProvider = ({ children = null }) => {
  const { i18n } = useTranslation();
  const lang = i18n.language || 'de';

  // TODO: fix centered popup position
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const width = 500;
  const height = 500;
  const popupFeatures = `location=no,toolbar=no,width=${width},height=${height},left=${(vw - width) / 2},top=${(vh - height) / 2}`;

  return (
    <AuthProvider
      authority={authority}
      automaticSilentRenew={true}
      client_id="frontend"
      extraQueryParams={{ lang }}
      loadUserInfo={true}
      redirect_uri={`${location.origin}/portal`}
      popupWindowFeatures={popupFeatures}
      popupWindowTarget="portalLogin"
    >
      {children}
    </AuthProvider>
  );
};

OAuthProvider.propTypes = {
  children: PropTypes.node,
};

export default OAuthProvider;
